<ng-container *ngIf="offer as o">
  <div class="job-card">
    <div class="company-info">
      <img
        [src]="companyLogoSrc || ''"
        alt="{{ o.companyName }} logo"
        class="company-logo"
      />
      <div class="title-block">
        <span class="company">{{ o.companyName }}</span>
        <h3 class="position">{{ o.title }}</h3>
        <p class="posted-date mobile">{{ getTimeAgo(o.createdAt) }}</p>
        <div class="location">
          <img src="../../../../../assets/icons/flags/4x3/de.svg" alt="German flag" class="flag"/>
          {{ o.location }}
        </div>
      </div>
      <p class="posted-date desktop">{{ getTimeAgo(o.createdAt) }}</p>
    </div>

    <div class="details">
      <span>{{ o.salaryRange }}</span>
    </div>

    <div class="tags">
      <span class="tag" *ngFor="let tag of o.tags">{{ tag }}</span>
    </div>
  </div>
</ng-container>
